import { Component, ChangeDetectionStrategy, HostBinding, ViewEncapsulation, Input, OnInit } from '@angular/core';
import { UxAppShellService } from '@eui/core';

@Component({
    selector: 'eui-header-logo',
    templateUrl: './header-logo.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
})
export class EuiHeaderLogoComponent implements OnInit {

    @HostBinding() class = 'eui-header-logo';

    @Input() homeUrl = '..';

    constructor(
        private asService: UxAppShellService,
    ) {}

    ngOnInit() {
        this.asService.setState({
            ...this.asService.state,
            hasHeaderLogo: true,
        });
    }
}
